<template>
  <div class="notification-log-row">
    <div class="name">{{ name }}</div>
    <div class="count">{{ notification_count }}</div>
  </div>
</template>

<script>
/* eslint-disable vue/prop-name-casing */
import Vue from "vue"

export default Vue.extend({
  props: {
    name: {
      type: null,
      default: undefined,
    },
    notification_count: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {}
  },
})
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.notification-log-row {
  display: grid;
  grid-gap: $space;
  grid-template-columns: auto auto;
  align-items: center;

  border-bottom: $border;
  padding: 15px 10px;

  font-size: 16px;

  > .count {
    text-align: right;
  }
}
</style>
